import React from 'react'
import { Stack, Table, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import { useViewMode } from '../ViewModeProvider'
import SummarizedLoansChart from './SummarizedLoansChart'

interface MetricConfig {
  label: string
  key: string
  map: Record<string, string>
}

interface PeriodConfig {
  label: string
  metrics: MetricConfig[]
}

const periodConfigs: PeriodConfig[] = [
  {
    label: '近1天',
    metrics: [
      {
        label: '贷款机构数',
        key: 'loan_info_xyp_cpl0070',
        map: { '0': '0', '1': '0-1', '2': '1-3', '3': '3+' },
      },
      {
        label: '还款成功笔数',
        key: 'loan_info_xyp_cpl0017',
        map: { '0': '0', '1': '0-3', '2': '3+' },
      },
      {
        label: '还款成功金额(元)',
        key: 'loan_info_xyp_cpl0033',
        map: { '0': '0', '1': '0-1500', '2': '1500-5000', '3': '5000+' },
      },
      {
        label: '交易失败笔数',
        key: 'loan_info_xyp_cpl0016',
        map: { '0': '0', '1': '0-3', '2': '3-5', '3': '5+' },
      },
      {
        label: '交易失败金额(元)',
        key: 'loan_info_xyp_cpl0032',
        map: { '0': '0', '1': '0-1500', '2': '1500-2500', '3': '2500-5000', '4': '5000+' },
      },
    ],
  },
  {
    label: '近7天',
    metrics: [
      {
        label: '贷款机构数',
        key: 'loan_info_xyp_cpl0009',
        map: { '0': '0', '1': '0-1', '2': '1-9', '3': '9+' },
      },
      {
        label: '还款成功笔数',
        key: 'loan_info_xyp_cpl0019',
        map: { '0': '0', '1': '0-3', '2': '3-13', '3': '13+' },
      },
      {
        label: '还款成功金额(元)',
        key: 'loan_info_xyp_cpl0035',
        map: { '0': '0', '1': '0-2000', '2': '2000-17000', '3': '17000+' },
      },
      {
        label: '交易失败笔数',
        key: 'loan_info_xyp_cpl0018',
        map: { '0': '0', '1': '0-3', '2': '3-5', '3': '5-7', '4': '7+' },
      },
      {
        label: '交易失败金额(元)',
        key: 'loan_info_xyp_cpl0034',
        map: { '0': '0', '1': '0-2000', '2': '2000-10000', '3': '10000-17000', '4': '17000-26000', '5': '26000+' },
      },
    ],
  },
  {
    label: '近14天',
    metrics: [
      {
        label: '贷款机构数',
        key: 'loan_info_xyp_cpl0010',
        map: { '0': '0', '1': '0-1', '2': '1-3', '3': '3-10', '4': '10+' },
      },
      {
        label: '还款成功笔数',
        key: 'loan_info_xyp_cpl0021',
        map: { '0': '0', '1': '0-5', '2': '5-21', '3': '21+' },
      },
      {
        label: '还款成功金额(元)',
        key: 'loan_info_xyp_cpl0037',
        map: { '0': '0', '1': '0-9000', '2': '9000-31000', '3': '31000+' },
      },
      {
        label: '交易失败笔数',
        key: 'loan_info_xyp_cpl0020',
        map: { '0': '0', '1': '0-3', '2': '3-5', '3': '5-15', '4': '15+' },
      },
      {
        label: '交易失败金额(元)',
        key: 'loan_info_xyp_cpl0036',
        map: { '0': '0', '1': '0-1000', '2': '1000-4000', '3': '4000-9000', '4': '9000-30000', '5': '30000+' },
      },
    ],
  },
  {
    label: '近21天',
    metrics: [
      {
        label: '贷款机构数',
        key: 'loan_info_xyp_cpl0063',
        map: { '0': '0', '1': '0-3', '2': '3-6', '3': '6-11', '4': '11+' },
      },
      {
        label: '还款成功笔数',
        key: 'loan_info_xyp_cpl0064',
        map: { '0': '0', '1': '0-5', '2': '5-27', '3': '27+' },
      },
      {
        label: '还款成功金额(元)',
        key: 'loan_info_xyp_cpl0067',
        map: { '0': '0', '1': '0-1000', '2': '1000-34000', '3': '34000+' },
      },
      {
        label: '交易失败笔数',
        key: 'loan_info_xyp_cpl0065',
        map: { '0': '0', '1': '0-3', '2': '3-5', '3': '5-20', '4': '20+' },
      },
      {
        label: '交易失败金额(元)',
        key: 'loan_info_xyp_cpl0066',
        map: { '0': '0', '1': '0-1000', '2': '1000-2000', '3': '2000-30000', '4': '30000-50000', '5': '50000+' },
      },
    ],
  },
  {
    label: '近30天',
    metrics: [
      {
        label: '贷款机构数',
        key: 'loan_info_xyp_cpl0011',
        map: { '0': '0', '1': '0-1', '2': '1-4', '3': '4-11', '4': '11+' },
      },
      {
        label: '还款成功笔数',
        key: 'loan_info_xyp_cpl0023',
        map: { '0': '0', '1': '0-7', '2': '7-34', '3': '34+' },
      },
      {
        label: '还款成功金额(元)',
        key: 'loan_info_xyp_cpl0039',
        map: { '0': '0', '1': '0-15000', '2': '15000-31000', '3': '31000-90000', '4': '90000-170000', '5': '170000+' },
      },
      {
        label: '交易失败笔数',
        key: 'loan_info_xyp_cpl0022',
        map: { '0': '0', '1': '0-3', '2': '3-5', '3': '5-20', '4': '20+' },
      },
      {
        label: '交易失败金额(元)',
        key: 'loan_info_xyp_cpl0038',
        map: { '0': '0', '1': '0-1000', '2': '1000-3000', '3': '3000-5000', '4': '5000-18000', '5': '18000+' },
      },
    ],
  },
]

const decode = (value: string, map: Record<string, string>) => map[value] ?? '—'

export default function SummarizedLoans({ data }: { data: any }) {
  const theme = useTheme()
  const { viewMode } = useViewMode()

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        还款与交易概览
      </Text>
      {viewMode === 'table' ? (
        <Stack gap="md" className="mt-3">
          {periodConfigs.map((period) => (
            <div key={period.label} className="flex flex-col gap-2">
              <Text size="xs" fw={600} className="text-gray-600">
                {period.label}
              </Text>
              <Table
                highlightOnHover
                withColumnBorders={false}
                verticalSpacing="sm"
                styles={{
                  table: { fontSize: '13px', tableLayout: 'fixed' },
                  th: {
                    backgroundColor: theme.surfaceMutedColor,
                    color: theme.accentTextColor,
                    whiteSpace: 'nowrap',
                  },
                }}
              >
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th style={{ width: '50%' }}>指标</Table.Th>
                    <Table.Th style={{ width: '50%' }}>区间</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {period.metrics.map((metric) => (
                    <Table.Tr key={metric.label}>
                      <Table.Td>{metric.label}</Table.Td>
                      <Table.Td>{decode(data?.[metric.key], metric.map)}</Table.Td>
                    </Table.Tr>
                  ))}
                </Table.Tbody>
              </Table>
            </div>
          ))}
        </Stack>
      ) : (
        <div className="mt-3">
          <SummarizedLoansChart data={data} />
        </div>
      )}
    </div>
  )
}
